import { AuthProvider } from './AuthContext';
import { HttpClientProvider } from './HttpClientContext';
import { I18nLoaderProvider } from './I18nLoaderContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function RequiredCrmContextProvider({
  isInCrmLocation = false,
  scopes,
  gates,
  httpClient,
  i18nLoader,
  children
}) {
  return /*#__PURE__*/_jsx(HttpClientProvider, {
    httpClient: httpClient,
    children: /*#__PURE__*/_jsx(AuthProvider, {
      scopes: scopes,
      gates: gates,
      isInCrmLocation: isInCrmLocation,
      children: /*#__PURE__*/_jsx(I18nLoaderProvider, {
        i18nLoader: i18nLoader,
        children: children
      })
    })
  });
}